import { Injectable } from '@angular/core';
import { User, CandidateService, UserService, JobService } from '@shared';
import { ALL_JOB_STATUS } from '@shared/models/job-statuses';
import { TalentPoolsService } from '@shared/services/talent-pools.service';
import { MojoEditorService } from 'mojo-editor/lib/mojo-editor.config';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class EditorService implements MojoEditorService {
  constructor(
    private candidateService: CandidateService,
    private userService: UserService,
    private jobService: JobService,
    private talentPoolsService: TalentPoolsService,
  ) {}

  candidateAutocomplete(apiParams: any): Observable<any[]> {
    return this.candidateService.autocomplete(apiParams);
  }

  getUsersList(usersIds: number[]): Observable<any[]> {
    return this.userService.getList(usersIds);
  }

  searchJobsForMentions(apiParams: any): Observable<any[]> {
    return this.jobService
      .searchJobs(apiParams, ALL_JOB_STATUS, true)
      .pipe(map((page) => page.content));
  }

  talentPoolAutocomplete(
    talentPoolName: string,
    size?: any,
    hasTalentPoolFeatureExtension?: any,
  ): Observable<any[]> {
    return this.talentPoolsService.autocomplete(
      talentPoolName,
      size,
      true,
      hasTalentPoolFeatureExtension,
    );
  }

  usersSearch(apiParams: any): Observable<any[]> {
    return this.userService.get({ params: apiParams }).pipe(map((page) => page.content));
  }
}
